import { IPaginationMeta } from "../types/ownerDashboard.types";

export function paginateItemsLocally<T>(
  items: T[],
  page: number,
  perPage: number
): { items: T[]; pagination: IPaginationMeta } {
  const safePerPage = Math.max(1, perPage);
  const total = items.length;
  const lastPage = Math.max(1, Math.ceil(total / safePerPage));
  const safePage = Math.min(Math.max(page, 1), lastPage);
  const startIndex = (safePage - 1) * safePerPage;

  return {
    items: items.slice(startIndex, startIndex + safePerPage),
    pagination: {
      current_page: safePage,
      per_page: safePerPage,
      total,
      last_page: lastPage,
    },
  };
}
